import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsStripedSkin = {
  ...textEffectsSharedSkin,
  'stripe-angle': {
    type: 'ANGLE',
    defaultValue: '0deg',
  },
  'stripe-size': {
    type: 'CSSString',
    defaultValue: '10px',
  },
  'inner-animation-speed': {
    type: 'ALPHA',
    defaultValue: '12.6',
  },
  'disable-inner-animation': {
    type: 'CSSString',
  },
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-2': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsStripedSkinDefinitionMap: Record<
  string,
  SiteAssetsSkinParams
> = {
  'wixui.skins.TextEffectsStriped': TextEffectsStripedSkin,
};

export default generateSkinDefaults(TextEffectsStripedSkinDefinitionMap);
